import React from 'react';
import { Bar, Creator, Del, Edit, Flex, NoteDetails, NoteDiv, StyledDate, SurgeryExchangeDetails, Time } from './CustomerCareNotes.styled';
import EditCard from './EditCard';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { FONT_FAMILY_DEMI } from 'src/styles/fonts/MCFontConstants';
import { logErrorToConsole } from 'src/utils/util';

const NotesOneDisplay = ({
    notesOneDisplay,
    editNoteOne,
    checkImpersonationActive,
    checkProxyActive,
    displayName,
    formatDateddmmmyy,
    countryISOCode,
    convertTime24To12,
    MDIEditDisable,
    MDIedit,
    handleEditOne,
    DeleteIcon,
    handleDelete,
    setNotesCount,
    editNoteValue,
    setEditNoteOneValue,
    CloseBlue,
    handleCloseEditOne,
    TickBlue,
    handleEditSaveOne,
    setEditNoteOne,
    setShowSuccessMessageOne,
    isFromConsignmentBilling,
    isFromReportUsage,

}) => {
        const { t } = useTranslation();
  return (
      <>
          <NoteDiv>
              {notesOneDisplay.filter(
                  ({ isReservationSetNote, typeOfNote }) => {
                      if (
                          isReservationSetNote === true &&
                          typeOfNote === 'BatchReservationNotes'
                      ) {
                          return false;
                      } else {
                          return true;
                      }
                  }
              ).length > 0 ? (
                  notesOneDisplay
                      .filter(({ isReservationSetNote, typeOfNote }) => {
                          if (
                              isReservationSetNote === true &&
                              typeOfNote === 'BatchReservationNotes'
                          ) {
                              return false;
                          } else {
                              return true;
                          }
                      })
                      .map((item, index) => (
                          <React.Fragment key={index}>
                              <Flex
                                  showBorder={
                                      editNoteOne === index || !item.isNew
                                          ? false
                                          : true
                                  }
                              >
                                  <div
                                      style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          width: '100%',
                                      }}
                                  >
                                      <Creator>
                                          {t('equity.surgery.createdBy')}{' '}
                                          {checkImpersonationActive() ||
                                          checkProxyActive()
                                              ? sessionStorage.getItem(
                                                    'ProxyUserRole'
                                                )
                                              : (item.userName
                                                    ? item.userName
                                                    : displayName) || ''}
                                      </Creator>
                                      <Bar>|</Bar>
                                      <StyledDate>
                                          {formatDateddmmmyy(
                                              item.creationDate,
                                              countryISOCode,
                                              true
                                          )}
                                      </StyledDate>
                                      <Bar>|</Bar>
                                      <Time>
                                          {convertTime24To12(
                                              new Date(item.creationDate)
                                          )}{' '}
                                      </Time>
                                  </div>
                                  {item?.isNew ? (
                                      <div
                                          style={{
                                              display: 'flex',
                                              gap: '10px',
                                          }}
                                      >
                                          <Edit>
                                              <img
                                                  src={
                                                      editNoteOne === index
                                                          ? MDIEditDisable
                                                          : MDIedit
                                                  }
                                                  alt="Edit note"
                                                  onClick={() =>
                                                      handleEditOne(item, index)
                                                  }
                                              />
                                          </Edit>
                                          <Del>
                                              <img
                                                  src={DeleteIcon}
                                                  onClick={() => {
                                                      handleDelete(
                                                          item,
                                                          index,
                                                          'notes1'
                                                      );
                                                      setNotesCount(
                                                          (prev) => prev - 1
                                                      );
                                                  }}
                                              />
                                          </Del>
                                      </div>
                                  ) : item?.isDelete ? (
                                      <div
                                          style={{
                                              display: 'flex',
                                              gap: '10px',
                                          }}
                                      >
                                          <Del>
                                              <img
                                                  src={DeleteIcon}
                                                  onClick={() => {
                                                      handleDelete(
                                                          item,
                                                          index,
                                                          'notes1'
                                                      );
                                                      setNotesCount(
                                                          (prev) => prev - 1
                                                      );
                                                  }}
                                              />
                                          </Del>
                                      </div>
                                  ) : null}
                              </Flex>
                              {editNoteOne === index && (
                                  <div
                                      style={{
                                          borderLeft: '2px solid #12c8f7',
                                      }}
                                  >
                                      <EditCard
                                          value={editNoteValue ?? item.note}
                                          editTextHandler={(e) => {
                                              setEditNoteOneValue(
                                                  e.target.value
                                              );
                                          }}
                                          CloseBlue={CloseBlue}
                                          closeEditHandler={handleCloseEditOne}
                                          TickBlue={TickBlue}
                                          blueTickHandler={() => {
                                              const isEmptyValue =
                                                  !editNoteValue ||
                                                  editNoteValue.trim() === '';

                                              handleEditSaveOne(index);
                                              setEditNoteOne(null);
                                              setEditNoteOneValue(null);
                                              if (!isEmptyValue) {
                                                  setShowSuccessMessageOne(
                                                      true
                                                  );
                                                  setTimeout(() => {
                                                      try {
                                                          setShowSuccessMessageOne(
                                                              false
                                                          );
                                                      }
                                                      catch (error) {
                                                          logErrorToConsole(error);
                                                      }
                                                  }, 4000);
                                              }
                                          }}
                                      />
                                  </div>
                              )}
                              {item.typeOfNote === 'CaseNotes' ? (
                                  <>
                                      {item.updatedSurgeryDate && (
                                          <div
                                              style={{
                                                  fontFamily: FONT_FAMILY_DEMI,
                                                  color: '#202124',
                                                  fontSize: '12px',
                                                  paddingLeft:
                                                      window.innerWidth <=
                                                      sizes.mobileDevice
                                                          ? '16px'
                                                          : '20px',
                                              }}
                                          >
                                              {item.updatedSurgeryDate}
                                          </div>
                                      )}
                                      <ol
                                          type="a"
                                          style={{
                                              paddingLeft:
                                                  window.innerWidth <=
                                                  sizes.mobileDevice
                                                      ? '16px'
                                                      : '20px',
                                              margin: '0',
                                          }}
                                      >
                                          {item.note
                                              .split(';')
                                              .map((element, index) => {
                                                  return (
                                                      <SurgeryExchangeDetails
                                                          key={index}
                                                      >
                                                          {element}
                                                      </SurgeryExchangeDetails>
                                                  );
                                              })}
                                      </ol>
                                  </>
                              ) : (
                                  editNoteOne !== index && (
                                      <NoteDetails
                                          hideBorder={item.isNew ? false : true}
                                      >
                                          {item.note}
                                      </NoteDetails>
                                  )
                              )}
                          </React.Fragment>
                      ))
              ) : (
                  <div
                      style={{
                          fontFamily: 'AvenirNextWorld Italic',
                          fontSize: '14px',
                          color: '#202124',
                          opacity: '0.7',
                          padding: '20px',
                      }}
                  >
                      {isFromConsignmentBilling
                          ? t(
                                'reportUsage.noCustomerCareConsignmentBillingNotes'
                            )
                          : isFromReportUsage
                          ? t('common.noCustomerCareUsageNotes')
                          : t(
                                'scheduleSurgery.surgery.SurgeryReviewAndSuccess.NoCustomeryet'
                            )}
                  </div>
              )}
          </NoteDiv>
      </>
  );
};

export default NotesOneDisplay;